import type { ValidationRow } from '@/api/users.service';
import { computed, inject, provide, toValue, type MaybeRefOrGetter } from 'vue';

export const AI_VALIDATION_CONTEXT_KEY = 'ai-validation';

export function provideAiValidation(fields: ValidationRow[]) {
  provide(AI_VALIDATION_CONTEXT_KEY, fields);
}

export function useAiValidation(fieldName: string) {
  const fieldValidation = inject<MaybeRefOrGetter<ValidationRow[]> | undefined>(
    AI_VALIDATION_CONTEXT_KEY,
    undefined,
  );
  return computed(() => {
    return toValue(fieldValidation)?.find((field) => field.field === fieldName)?.validation;
  });
}
